import {
  BarChart3, Boxes, CircleUserRound, FileBarChart, Folder, LayoutGrid, LifeBuoy, Lock, Receipt, SlidersHorizontal, Table2, Users, Wallet,
  Wrench, Sparkles, type LucideIcon,
} from 'lucide-react';
import type { MenuNode } from '@/lib/types';

/** Ana menü grubu ikonu (Delphi ana menü TAG'leri 100..900) */
const GROUP_ICON: Record<number, LucideIcon> = {
  100: Wrench, 200: Boxes, 300: Users, 400: Receipt, 500: Wallet, 600: CircleUserRound, 700: BarChart3, 800: SlidersHorizontal, 900: LifeBuoy,
};
export function groupIcon(n: MenuNode): LucideIcon {
  if (n.tag && GROUP_ICON[n.tag]) return GROUP_ICON[n.tag];
  const t = n.title.toLocaleLowerCase('tr-TR');
  if (t.includes('servis')) return Wrench;
  if (t.includes('stok')) return Boxes;
  if (t.includes('cari')) return Users;
  if (t.includes('fatura')) return Receipt;
  if (t.includes('kasa') || t.includes('banka')) return Wallet;
  if (t.includes('rapor')) return BarChart3;
  return Folder;
}
export function leafIcon(kind: string): LucideIcon {
  switch (kind) {
    case 'dizayn': case 'dizayn-belge': return LayoutGrid;
    case 'tablo': return Table2;
    case 'rapor-grup': return FileBarChart;
    case 'harici': return Lock;
    default: return Sparkles;
  }
}

export interface FlatItem { node: MenuNode; path: string[] }
/** Komut paleti için yaprak düğümler */
export function flatten(nodes: MenuNode[], path: string[] = []): FlatItem[] {
  const out: FlatItem[] = [];
  for (const n of nodes) {
    if (n.children?.length) out.push(...flatten(n.children, [...path, n.title]));
    else out.push({ node: n, path });
  }
  return out;
}

export const trLower = (s: string) => s.toLocaleLowerCase('tr-TR');

/** Türkçe karakter ve büyük/küçük harf duyarsız eşleşme; puan döner (0 = eşleşmedi) */
export function matchScore(text: string, q: string): number {
  if (!q) return 1;
  const t = trLower(text), s = trLower(q.trim());
  if (t === s) return 4;
  if (t.startsWith(s)) return 3;
  if (t.split(/[\s\-/·]+/).some((w) => w.startsWith(s))) return 2;
  if (t.includes(s)) return 1;
  // baş harfler (ör. "sf" → Satış Faturası)
  const ini = t.split(/[\s\-/]+/).map((w) => w[0]).join('');
  return ini.includes(s) ? 0.5 : 0;
}
